import { useMutation, useQueryClient } from "@tanstack/react-query";
import { systemCopyService } from "@/services/system-copy-service";
import { tenantCatalogKeys } from "@/components/pages/tenants/hooks/useTenants";
import { hotelKeys } from "@/components/pages/hotels/hooks/useHotels";
import { CopyHotelRequestDto, CopyTenantRequestDto } from "@/types/system-copy";

export const useCopyTenant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CopyTenantRequestDto) =>
      systemCopyService.copyTenant(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantCatalogKeys.lists() });
      queryClient.invalidateQueries({ queryKey: hotelKeys.lists() });
    },
  });
};

export const useCopyHotel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CopyHotelRequestDto) => systemCopyService.copyHotel(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: hotelKeys.lists() });
    },
  });
};
